import React from 'react';
import {Route, Routes} from 'react-router-dom';

// 页面组件
import Home from "../pages/Home";
import MonitorPage from "../pages/Monitor";
import About from "../pages/About";
import Demo from "../pages/Demo";
import Galleries from "../pages/Galleries";
import ImageProcessing from "../pages/ImageProcessing";
import FormatConvert from "../pages/FormatConvert";
import ImageCompress from "../pages/ImageCompress";
import AIGenerate from "../pages/AIGenerate";
import ImageSearch from "../pages/ImageSearch";
import Trash from "../pages/Trash";
import Invite from "../pages/Invite";
import InviteWelcome from "../pages/InviteWelcome";
import EncryptedLinks from "../pages/EncryptedLinks";
import NotFound from "../pages/NotFound";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/img-cloud/index.html" element={<Home />} />
      <Route path="/galleries" element={<Galleries />} />
      <Route path="/monitor" element={<MonitorPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/image-processing" element={<ImageProcessing />} />
      <Route path="/format-convert" element={<FormatConvert />} />
      <Route path="/image-compress" element={<ImageCompress />} />
      <Route path="/ai-generate" element={<AIGenerate />} />
      <Route path="/image-search" element={<ImageSearch />} />
      <Route path="/trash" element={<Trash />} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/invite-welcome" element={<InviteWelcome />} />
      <Route path="/encrypted-links" element={<EncryptedLinks />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes; 